import { t } from '../config/i18n';
import { formatString } from './utils';

export type MessageType = 'info' | 'warn' | 'error' | 'login';
// export const changeCurrencyEvent = 'changeCurrency';

export interface Message {
  type: MessageType;
  text: string;
}

export type MessagesListener = (message: Message) => void;

const messagesListeners: MessagesListener[] = [];

export function listenMessages(listener: MessagesListener) {
  messagesListeners.push(listener);
}

export function stopListenMessages(listener: MessagesListener) {
  const n = messagesListeners.indexOf(listener);
  if (n !== -1) {
    messagesListeners.splice(n, 1);
  }
}

export function showMessage(type, text: string) {
  for (const listener of messagesListeners) {
    listener({ type, text });
  }
}

export interface Notifications {
  deals: Record<string, number[]>;
  disputes: Record<string, number[]>;
  messages: Record<string, number[]>;
  unreadGroups: number;
}

export type NotificationsListener = (notifications: Notifications) => void;

const notificationsListeners: NotificationsListener[] = [];

export function listenNotifications(listener: NotificationsListener) {
  notificationsListeners.push(listener);
}

export function stopListenNotifications(listener: NotificationsListener) {
  const n = notificationsListeners.indexOf(listener);
  if (n !== -1) {
    notificationsListeners.splice(n, 1);
  }
}

export function newNotifications(notifications: Notifications) {
  for (const listener of notificationsListeners) {
    listener(notifications);
  }
}

const notificationSound = new Audio('/sound/time-is-now.mp3');

notificationSound.load();

let notificationSoundPlaying = false;

export function playNotificationSound() {
  if (!notificationSoundPlaying) {
    notificationSoundPlaying = true;
    notificationSound.load();
    notificationSound
      .play()
      .then()
      .catch((e) => console.log('cannot play sound:', e))
      .finally(() => (notificationSoundPlaying = false));
  }
}

const errorMasks = [
  { pattern: /'.*' is too short - 'address'/, error: 'errors.Wrong address' },
];

export function checkErrorByMask(error: string): string | undefined {
  for (const mask of errorMasks) {
    const match = error.match(mask.pattern);
    if (match) {
      return formatString(t(mask.error), ...match.slice(1));
    }
  }
  return;
}
